import { ReactNode } from "react";

interface OverviewKpiCardProps {
  label: string;
  value: ReactNode;
  subValue?: ReactNode;
  footer?: ReactNode;
}

export default function OverviewKpiCard({ label, value, subValue, footer }: OverviewKpiCardProps) {
  return (
    <div className="flex-1 bg-white border border-gray-200 rounded-md p-4 min-w-[140px]">
      <div className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">{label}</div>
      <div className="mt-2 flex items-baseline gap-2">
        <div className="text-2xl font-semibold text-gray-900">{value}</div>
        {subValue && <div className="text-sm text-gray-500">{subValue}</div>}
      </div>
      {footer && <div className="mt-2 text-xs text-gray-500">{footer}</div>}
    </div>
  );
}
